import { get, post, post_token } from '../service'

const home = {
    //运单监控
    TransportDocTracking(params) {
        return post('/TransportDocTracking', params)
    },
}

export default home;


// WEBPACK FOOTER //
// ./src/api/modules/home.api.js